import _extends from "../../../@babel/runtime/helpers/esm/extends.es.js";
const GLOBAL_API_REF = {
  current: null
};
function tagInternalFilter(fn) {
  fn.isInternal = true;
  return fn;
}
function isInternalFilter(fn) {
  return fn !== void 0 && fn.isInternal === true;
}
function convertFilterV7ToLegacy(fn) {
  return tagInternalFilter((filterItem, column) => {
    const filterFn = fn(filterItem, column);
    if (!filterFn) {
      return filterFn;
    }
    return (cellParams) => {
      return filterFn(cellParams.value, cellParams.row, column, GLOBAL_API_REF.current);
    };
  });
}
function convertLegacyOperators(ops) {
  return ops.map((op) => {
    return _extends({}, op, {
      getApplyFilterFn: convertFilterV7ToLegacy(op.getApplyFilterFnV7),
      getApplyFilterFnV7: tagInternalFilter(op.getApplyFilterFnV7)
    });
  });
}
function convertQuickFilterV7ToLegacy(fn) {
  return tagInternalFilter((filterItem, column, apiRef) => {
    const filterFn = fn(filterItem, column, apiRef);
    if (!filterFn) {
      return filterFn;
    }
    return (cellParams) => {
      return filterFn(cellParams.value, cellParams.row, column, apiRef);
    };
  });
}
export {
  GLOBAL_API_REF,
  convertFilterV7ToLegacy,
  convertLegacyOperators,
  convertQuickFilterV7ToLegacy,
  isInternalFilter,
  tagInternalFilter
};
//# sourceMappingURL=utils.es.js.map
